<!-- Secțiunea Date Identificare -->
<div class="g-0">
    <div class="row">
        <div class="col-md">
            <div class="box-wrapper box-info">
                <div class="box-content-header">
                    <div class="row p-1">
                        <div class="col">
                            <div class="d-flex justify-content-between align-items-center">
                                <mat-card-title>
                                    <i class="fa-solid fa-user"></i>
                                    <span>Identificare</span>
                                </mat-card-title>
                                <div class="d-flex justify-content-between align-items-center gap-2">
                                    <button class="btn btn-small btn-warning edit-btn" title="Editează"
                                        (click)="openEditSubsemnat()">
                                        <i class="fa fa-pencil fa-sm"></i>
                                    </button>
                                    <button class="btn btn-small btn-light edit-btn" title="Istoric"
                                        (click)="openIstoricSubsemnat()">
                                        <i class="fa-solid fa-clock-rotate-left"></i>
                                    </button>
                                    <!-- <button class="btn btn-small btn-info edit-btn" title="Descarcă"
                                        (click)="downloadChanges('identificare', 1)">
                                        <i class="fa fa-download fa-sm"></i>
                                    </button> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box-content-body">
                    <ng-container *ngIf="selectedBeneficiarStatus === 'info'">
                        <table class="table table-condensed table-wrapper-box mb-0">
                            <tbody>
                                <tr>
                                    <td width="40%" class="text-center">
                                        <strong><i class="fa-solid fa-user me-1"></i>Nume</strong>
                                    </td>
                                    <td class="text-left">{{ beneficiar.last_name }} {{ beneficiar.first_name }}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-center">
                                        <strong><i class="fa-solid fa-calendar me-1"></i>Data nașterii</strong>
                                    </td>
                                    <td class="text-left">{{ beneficiar.birth_date | date: "dd.MM.yyyy" : "ro" }}</td>
                                </tr>
                                <tr>
                                    <td class="text-center">
                                        <strong><i class="fa-solid fa-id-card me-1"></i>{{ "CNP" }}</strong>
                                    </td>
                                    <td class="text-left">{{ beneficiar.cnp }}</td>
                                </tr>
                                <tr>
                                    <td class="text-center">
                                        <strong><i class="fa-solid fa-phone me-1"></i>Telefon</strong>
                                    </td>
                                    <td class="text-left">{{ beneficiar.phone || 'n/a' }}</td>
                                </tr>
                                <tr>
                                    <td class="text-center">
                                        <strong><i class="fa-solid fa-envelope me-1"></i>Email</strong>
                                    </td>
                                    <td class="text-left">{{ beneficiar.email || 'n/a' }}</td>
                                </tr>
                                <tr>
                                    <td class="text-center">
                                        <strong><i class="fa-solid fa-sticky-note me-1"></i>Observații</strong>
                                    </td>
                                    <td class="text-left">{{ beneficiar.notes || 'n/a'}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Secțiunea Localizare/adresa resedinta -->
<div class="g-0">
    <div class="row">
        <div class="col-md">
            <div class="box-wrapper box-info">
                <div class="box-content-header">
                    <div class="row p-1">
                        <div class="col">
                            <div class="d-flex justify-content-between align-items-center">
                                <mat-card-title>
                                    <i class="fa-solid fa-house"></i>
                                    <span>Localizare/Adresă reședință</span>
                                </mat-card-title>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box-content-body">
                    <div class="d-flex justify-content-end m-2 gap-2">
                        <div class="view-toggle">
                            <button [class.active]="currentViewLocalizari === ViewMode.ALL"
                                (click)="setViewModeLocalizari(ViewMode.ALL)" matTooltip="Toate">
                                Toate
                            </button>
                            <button [class.active]="currentViewLocalizari === ViewMode.ACTIVE"
                                (click)="setViewModeLocalizari(ViewMode.ACTIVE)" matTooltip="Active">
                                Active
                            </button>
                            <button [class.active]="currentViewLocalizari === ViewMode.INACTIVE"
                                (click)="setViewModeLocalizari(ViewMode.INACTIVE)" matTooltip="Inactive">
                                Inactive
                            </button>
                        </div>
                        <button class="btn btn-primary btn-sm" (click)="openAddLocation()">
                            <i class="fa-solid fa-plus"></i>
                            <span> Adaugă Localizare</span>
                        </button>
                    </div>
                    <mat-divider></mat-divider>
                    <table class="table table-condensed table-wrapper-box">
                        <thead>
                            <tr>
                                <th>Crt.</th>
                                <th>Situație copil</th>
                                <th>De la</th>
                                <th>Până la</th>
                                <th>Adresă</th>
                                <th>Acțiuni</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="!filteredLocalizari.length">
                                <td colspan="6" class="text-center">
                                    <strong><i>Lipsă înregistrări</i></strong>
                                </td>
                            </tr>
                            <ng-container *ngIf="filteredLocalizari.length">
                                <tr *ngFor="let row of filteredLocalizari; let i = index;"
                                    [ngClass]="{'inactive-row': !row.is_active || row.is_deleted, 'deleted-row': row.is_deleted}">
                                    <td>
                                        <div class="d-flex gap-2">
                                            <span>{{ i + 1 }}</span>
                                        </div>
                                    </td>
                                    <td>
                                        {{ row.situation_type_name }}
                                    </td>
                                    <td>
                                        {{ row.date_from ? (row.date_from | date: 'dd.MM.yyyy') : 'n/a' }}
                                    </td>
                                    <td>
                                        {{ row.date_to ? (row.date_to | date: 'dd.MM.yyyy') : 'n/a' }}
                                    </td>
                                    <td>
                                        {{ row.adresa_centru && row.adresa_centru.web_name ? ('Centru: ' +
                                        row.adresa_centru.web_name) :
                                        row.adresa?.formatted_address }}
                                    </td>
                                    <td>
                                        <div class="d-flex align-center justify-content-left flex-wrap gap-1">
                                            <button *ngIf="!row.is_deleted" class="action-btn edit" title="Editează"
                                                (click)="openEditLocation(row.id)">
                                                <img class="btn-img" src="../../../../assets/icons/edit.svg"
                                                    alt="edit" />
                                            </button>
                                            <button *ngIf="!row.is_deleted" class="action-btn delete" title="Șterge"
                                                (click)="deleteLocation(row.id)">
                                                <img class="btn-img" src="../../../../assets/icons/delete.svg"
                                                    alt="delete" />
                                            </button>
                                            <button *ngIf="row.is_deleted" (click)="resetLocation(row.id)"
                                                class="action-btn edit p-1"
                                                style="color: white; font-size: 11px; line-height: 1;">
                                                <span>Resetare</span>
                                            </button>
                                            <button class="action-btn view" title="Istoric"
                                                (click)="openIstoricLocation(row)"
                                                style="background-color: #efefef; border-color: #bdbdbd;">
                                                <img class="btn-img"
                                                    src="../../../../assets/icons/clock-rotate-left.svg" alt="view" />
                                            </button>
                                            <!-- <button class="action-btn download"
                                                style="color: #000; font-size: 11px; line-height: 1" title="Descarcă"
                                                (click)="downloadChanges('localizare', row.id)">
                                                <span class="btn-img">
                                                    <i class="fa fa-download fa-sm"></i>
                                                </span>
                                            </button> -->
                                            <!-- <div *ngIf="row.is_deleted" class=""
                                                style="background-color: #FF5B5B;color: white; border-radius: 4px; padding: 2px; font-size: 12px;">
                                                Dezactivat</div> -->
                                        </div>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Relatii Familiale/Gardian(Parinte adoptiv) -->
<div class="g-0">
    <div class="row">
        <div class="col">
            <div class="box-wrapper box-info">
                <div class="box-content-header">
                    <div class="row p-1">
                        <div class="col">
                            <mat-card-title>
                                <i class="fa-solid fa-list"></i>
                                <span>Relații Familiale/Gardian(Părinte adoptiv)</span>
                            </mat-card-title>
                        </div>
                    </div>
                </div>
                <div class="box-content-body">
                    <div class="d-flex justify-content-end m-2 gap-2">
                        <div class="view-toggle">
                            <button [class.active]="currentViewRelationships === ViewMode.ALL"
                                (click)="setViewModeRelationships(ViewMode.ALL)" matTooltip="Toate">
                                Toate
                            </button>
                            <button [class.active]="currentViewRelationships === ViewMode.ACTIVE"
                                (click)="setViewModeRelationships(ViewMode.ACTIVE)" matTooltip="Active">
                                Active
                            </button>
                            <button [class.active]="currentViewRelationships === ViewMode.INACTIVE"
                                (click)="setViewModeRelationships(ViewMode.INACTIVE)" matTooltip="Inactive">
                                Inactive
                            </button>
                        </div>
                        <button class="btn btn-primary btn-sm" (click)="openAddRelationship()">
                            <i class="fa-solid fa-plus"></i>
                            <span> Adaugă Relație</span>
                        </button>
                    </div>
                    <mat-divider></mat-divider>
                    <table class="table table-condensed table-wrapper-box">
                        <thead>
                            <tr>
                                <th>Crt.</th>
                                <th>Nume</th>
                                <th>Relația cu beneficiarul</th>
                                <th>Grad rudenie</th>
                                <th>Status</th>
                                <th>Confirmare Status</th>
                                <th>Acțiuni</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="!filteredRelationships.length">
                                <td colspan="7" class="text-center">
                                    <strong><i>Lipsă înregistrări</i></strong>
                                </td>
                            </tr>
                            <ng-container *ngIf="filteredRelationships.length">
                                <tr *ngFor="let row of filteredRelationships; let i = index;"
                                    [ngClass]="{'inactive-row': !row.is_active || row.is_deleted, 'deleted-row': row.is_deleted}">
                                    <td>
                                        {{ i + 1 }}
                                    </td>
                                    <td class="redirect-td" (click)="openInNewTab(row.related_entity_id)">
                                        {{ row.related_entity_name }}
                                    </td>
                                    <td>
                                        {{ row.relationship_type_name }}
                                    </td>
                                    <td>
                                        {{ row.relationship_specific_name || 'n/a' }}
                                    </td>
                                    <td>
                                        <div [ngStyle]="{'background-color': row.relationship_status_color}"
                                            style="color: white; border-radius: 4px; padding: 3px 10px">{{
                                            row.relationship_status_name }}</div>
                                    </td>
                                    <td>
                                        <div *ngIf="row.relationship_confirmation_status_name"
                                            [ngStyle]="{'background-color': row.relationship_confirmation_status_color}"
                                            style="color: white; border-radius: 4px; padding: 3px 10px">{{
                                            row.relationship_confirmation_status_name }}</div>
                                        <div *ngIf="!row.relationship_confirmation_status_name">{{ 'n/a' }}</div>
                                    </td>
                                    <td>
                                        <div class="d-flex align-center justify-content-left flex-wrap gap-1">
                                            <button *ngIf="!row.is_deleted" class="action-btn edit" title="Editează"
                                                (click)="openEditRelationship(row.id)">
                                                <img class="btn-img" src="../../../../assets/icons/edit.svg"
                                                    alt="edit" />
                                            </button>
                                            <button *ngIf="!row.is_deleted" class="action-btn delete" title="Șterge"
                                                (click)="deleteRelationship(row.id)">
                                                <img class="btn-img" src="../../../../assets/icons/delete.svg"
                                                    alt="delete" />
                                            </button>
                                            <button *ngIf="row.is_deleted" (click)="resetRelationship(row.id)"
                                                class="action-btn edit p-1"
                                                style="color: white; font-size: 11px; line-height: 1;">
                                                <span>Resetare</span>
                                            </button>
                                            <button class="action-btn view" title="Istoric"
                                                (click)="openIstoricRelationship(row)"
                                                style="background-color: #efefef; border-color: #bdbdbd;">
                                                <img class="btn-img"
                                                    src="../../../../assets/icons/clock-rotate-left.svg" alt="view" />
                                            </button>
                                            <!-- <button class="action-btn download"
                                                style="color: #000; font-size: 11px; line-height: 1" title="Descarcă"
                                                (click)="downloadChanges('relatie', row.id)">
                                                <span class="btn-img">
                                                    <i class="fa fa-download fa-sm"></i>
                                                </span>
                                            </button> -->
                                            <!-- <div *ngIf="row.is_deleted" class=""
                                                style="background-color: #FF5B5B;color: white; border-radius: 4px; padding: 2px; font-size: 12px;">
                                                Dezactivat</div> -->
                                        </div>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>